import { AxiosRequestConfig } from 'axios';

/**
 * API service options
 */
export interface IAPIOptions {
    /**
     * Axios Config
     */
    axiosConfig: AxiosRequestConfig;

    /**
     * The base url that will serve as prefix for requested urls
     */
    baseUrl: string | 'auto';

    /**
     * Serve the project name via `requesting_from` property
     */
    platform: string;

    /**
     * Type of the api requests:
     * - public: Frontend requests
     * - private: Backend requests
     */
    type: 'private' | 'public';

    /**
     * Serve the wholesaler id via `wholesaler_id` property
     */
    wholesaler_id: number | undefined;
}

/**
 * Default API service options
 */
export const DEFAULT_API_OPTIONS: Partial<IAPIOptions> = {
    axiosConfig: {},
    platform: 'sdk:v1',
    type: 'public',
};
